import {createLogger, createStore} from 'vuex'
import auth from '@/store/modules/auth'
import service_monitoring from "@/store/modules/service_monitoring";
import tools from "@/store/modules/tools";

const debug = process.env.NODE_ENV !== 'production'

const state = () => ({
    processing: 0,
    countries: null
})

const getters = {}

const actions = {
}

const mutations = {
    get_processing_lock(state) {
        state.processing += 1
    },
    release_processing_lock(state) {
        state.processing -= 1
    },
}

export default createStore({
    modules: {
        auth, service_monitoring, tools
    },
    state,
    actions,
    getters,
    mutations,
    strict: debug,
    plugins: debug ? [createLogger()] : []
})